import type { ApiContract } from "hyview-api-connector";

import type { WatchlistDto } from "$src/core/models/dto";
import Storage from "$src/core/services/storage/storage";

const getWatchlist = async (
  api: ApiContract,
  profileId: string,
): Promise<WatchlistDto> => {
  const watchlist = Storage.get("watchlist");

  const ids = watchlist?.[profileId] ?? [];

  if (ids.length === 0) {
    return {
      items: [],
    };
  }

  const items = await Promise.all(
    ids.map(async (id) => api.getBaseContentById(id)),
  );

  return {
    items: items.filter((item) => item !== null) as WatchlistDto["items"],
  };
};

export default getWatchlist;
